import GoogleAutoCompleteField from "../../../globals/components/forms/GoogleAutoCompleteField";
import { textFieldSx } from "../hooks/useFirstTimeRegister";

const RegisterGoogleAutoComplete = (props) => (
  <GoogleAutoCompleteField
    sx={textFieldSx}
    initDelayMs={100}
    searchIconPosition="start"
    registerPacStyles
    {...props}
  />
);

export default RegisterGoogleAutoComplete;
